<template>
  <v-container v-if="this.zamawiajacy" class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
  </div>
</div>

  </td></tr>
  </thead>
<tbody>
<tr><td>

  <p align="center" style="margin-top:20px;">
      <strong>UMOWA O WSPÓŁPRACY</strong>
  </p>
  <p>
      Zawarta w Łodzi pomiędzy:
  </p>
  <p>
    <b>Tutore Poland Sp. z o.o.</b> z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla Łodzi-Śródmieścia w Łodzi, XX Wydział Krajowego Rejestru Sądowego pod nr KRS 0000670834, NIP: 727-28-12-193, REGON: 366891567
  </p>
  <p>reprezentowaną przez:</p>
  <p>{{ zamawiajacy }},</p>
  <p>zwaną dalej <b>„Zleceniodawcą”</b></p>
  <p>
    a
  </p>
  <p>{{ imieNazwisko }} prowadzącą/cym działalność gospodarczą pod nazwą: {{ nazwaFirmy }} w {{ miejscowosc }} (kod {{ kodPocztowy }}) przy ul. {{ adresZamieszkania }}, NIP: {{ nip }}, REGON: {{ regon }}</p>
  <p>zwaną/ym dalej <b>„Zleceniobiorcą”</b></p>

  <p>o następującej treści:</p>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 1 Przedmiot umowy</strong>
</p>
<ol>
  <li style="margin-bottom: 0px;">Na podstawie niniejszej Umowy, Zleceniodawca zleca, a Zleceniobiorca zobowiązuje się w zakresie prowadzonej przez siebie działalności gospodarczej do świadczenia usług (dalej <b>Usługi</b>) polegających na:
    <ol type="a">
      <li>reprezentowanie Zleceniodawcy wobec osób prywatnych, firm i instytucji, znajomość oferty i udzielanie</li>
      <li>informacji w zakresie oferowanych przez Zleceniodawcę usług i produktów</li>
      <li>sporządzanie raportów i podsumowań z pracy własnej</li>
      <li>prezentowanie oferty usług oferowanych przez Zleceniodawcę przed potencjalnymi klientami w szkołach i innych placówkach bądź firmach oraz przede wszystkim przed klientami indywidualnymi</li>
      <li>działania związane ze sprzedażą i promocją usług oferowanych przez Zleceniodawcę w tym organizowanie akcji promocyjnych, badanie rynku i konkurencji</li>
      <li>realizacja celów budżetowych i jakościowych w projekcie wyznaczonych przez Zleceniodawcę</li>
      <li>inne zadania zlecone przez Zleceniodawcę.</li>
    </ol>
  </li>
  <li>Zleceniobiorca oświadcza, że zapoznał się z misją i wizją Zleceniodawcy, przyjętymi u Zleceniodawcy standardami oraz obowiązującymi u Zleceniodawcy regulacjami wewnętrznymi oraz że w razie dokonania ich zmian, zmiany te będą skuteczne pomiędzy stronami. W szczególności, podczas wykonywania      Usługi, Zleceniobiorca zobowiązany jest do dbania o dobro Zleceniodawcy i ochronę jego mienia, w tym do dołożenia najwyższej staranności celem zapewnienia zgodności wszystkich podejmowanych czynności z odpowiednimi politykami, standardami, wytycznymi, kodeksami branżowymi i procedurami (dalej łącznie: <b>„Dokumenty”</b>) obowiązującymi u Zleceniodawcy, które zostaną Zleceniobiorcy udostępnione. Zleceniodawca zobowiązuje Zleceniobiorcę do postępowania zgodnie z zasadami zawartymi w Dokumentach, a ich nieprzestrzeganie może być podstawą do rozwiązania niniejszej umowy w trybie natychmiastowym, z przyczyn leżących po stronie Zleceniobiorcy.</li>
  <li>Zleceniobiorca oświadcza, że posiada wiedzę i doświadczenie, które zapewnią należyte i terminowe wywiązanie się z postanowień niniejszej umowy. Zleceniobiorca oświadcza, że zobowiązuje się wykonywać Umowę ze szczególną starannością wymaganą od profesjonalisty, z uwzględnieniem obowiązujących przepisów prawa, standardów i reguł wykonywania prac objętych niniejszą umową, a także zasad etyki zawodowej oraz dbając o interesy Zleceniodawcy.</li>
  <li>Poza wymienionymi wyżej usługami Zleceniobiorca zobowiązuje się również do przeniesienia na Zamawiającego na zasadach i w zakresie wskazanym w § 9 niniejszej umowy autorskich praw majątkowych i praw pokrewnych oraz zależnych odnośnie wszelkich utworów wytworzonych przez Zleceniobiorcę lub z jego udziałem w wyniku wykonania usług. Wynagrodzenie zostało skalkulowane w sposób uwzględniający zapłatę za przeniesienie praw autorskich majątkowych, praw pokrewnych oraz praw zależnych.</li>
  <li>Zleceniodawca ma możliwość za zgodą Zleceniobiorcy zlecić mu dodatkowe prace związane z zakresem niniejszej umowy, za które będzie przysługiwało Zleceniobiorcy dodatkowe wynagrodzenie w kwocie określonej w § 3 pkt 2. Zleceniobiorca po zapoznaniu się z wykazem dodatkowych prac ma prawo podjąć się ich wykonania lub zrezygnować z nich.</li>
  <li>Przy realizacji Usług Zleceniobiorca może posługiwać się tytułem Host/ Hostessa.</li>
</ol>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 2 Zasady świadczenia Usług</strong>
</p>
<ol>
  <li>Zleceniobiorca wykona powierzone czynności osobiście (Usługi), z dołożeniem należytej staranności, wymaganej od profesjonalisty.</li>
  <li>Miejsce i czas świadczenia usług będzie określał Zleceniobiorca, biorąc pod uwagę potrzeby, charakter czynności objętych zakresem usług oraz aktualne i przyszłe potrzeby Zleceniodawcy.</li>
  <li>Zleceniodawca zapewni Zleceniobiorcy dostęp do informacji i dokumentów, które będą niezbędne do wykonania umowy. Zleceniobiorca  będzie  posługiwał  się  materiałami  informacyjnymi dostarczonymi  przez  Zleceniodawcę.</li>
  <li>W celu umożliwienia wykonywania usług, w zależności od potrzeb, także w siedzibie Zleceniodawcy, Zleceniodawca umożliwi Zleceniobiorcy korzystanie ze wskazanych pomieszczeń, sprzętu, programów i urządzeń. Decyzję w zakresie przekazania pomieszczeń, sprzętu, programów i urządzeń podejmuje Zleceniodawca.</li>
  <li>W celu prawidłowego wykonania usług stanowiących przedmiot umowy, Zleceniodawca  udostępnia Zleceniobiorcy telefon wraz z kartą SIM oraz komputer wraz z oprogramowaniem. Na zasadach określonych w odrębnej umowie Zleceniodawca może powierzyć Zleceniobiorcy sprzęt audiowizualny do wykonania Usług.</li>
  <li>Przekazanie i zwrot przez Zleceniobiorcę sprzętu udostępnionego przez Zleceniodawcę potwierdzone zostaną protokołem odbioru i protokołem zwrotu podpisanym przez obie strony.</li>
  <li>Zleceniobiorca ma prawo korzystać z udostępnionego sprzętu wyłącznie do celów realizacji umowy.</li>
  <li>Zleceniobiorca zwróci Zleceniodawcy sprzęt, o którym mowa ust. 5 powyżej w dniu rozwiązania umowy, a także na każde pisemne żądanie Zleceniodawcy. Zleceniobiorca ponosi odpowiedzialność za zniszczenie lub uszkodzenie udostępnionego sprzętu.</li>
  <li>Strony zgodnie oświadczają, że wynagrodzenie Zleceniobiorcy z tytułu wykonywania niniejszej umowy zostało skalkulowane w taki sposób, że uwzględnia wykorzystywanie przez Zleceniobiorcę środków technicznych oraz powierzonego sprzętu.</li>
  <li>W czasie obowiązywania niniejszej Umowy Zleceniobiorca zobowiązuje się do odbywania szkoleń określonych przez Zleceniodawcę pod rygorem zapłaty kary umownej w wysokości 1.000 (słownie: jeden tysiąc 0/100) złotych za każde nieodbyte lub odbyte nieterminowo szkolenie. </li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 3 Wynagrodzenie</strong>
</p>
  <ol>
    <li>Zleceniodawca zobowiązuje się do wypłaty, z tytułu właściwego wykonywania Usług w danym miesiącu kalendarzowym wynagrodzenia w wysokości obliczonej jako iloczyn stawki godzinowej w wysokości xxxxx zł netto (słownie: xxxxxx złotych netto) za 1 godzinę wykonywania Usług oraz ilości przepracowanych przez Zleceniobiorcę godzin w danym miesiącu, powiększonej o obowiązującą w dniu wystawienia faktury vat stawkę VAT (podatku od towarów i usług) za każdy miesiąc świadczonych na rzecz Zleceniodawcy Usług.</li>
    <li>Dodatkowe wynagrodzenie, o którym mowa w §1 pkt 5, będzie uzależnione od czasu poświęconego na realizację danego zlecenia i będzie uzgodnione przez obie Strony umowy każdorazowo przed rozpoczęciem prac.</li>
    <li>Wynagrodzenie, o którym mowa w ust. 1 i 2 powyżej, będzie wypłacane na podstawie prawidłowo wystawionej faktury vat, przy czym podstawę do wystawienia faktury stanowi zaakceptowane przez Zleceniodawcę Zestawienia liczby godzin świadczonych Usług w miesiącu. W przypadku gdy Zleceniobiorca jest zwolniony z podatku od towarów i usług, wynagrodzenie wskazane w ust. 1 i 2 powyżej nie będzie powiększane o stawkę VAT, a podstawę do wypłaty wynagrodzenia stanowić będzie prawidłowo wystawiona faktura.</li>
    <li>Zleceniobiorca przedstawia Zleceniodawcy zestawienie liczby godzin świadczenia Usług przez Zleceniobiorcę w każdym miesiącu kalendarzowym, w którym Usługi były wykonywane za pośrednictwem poczty elektronicznej (na adres e-mail upoważnionego przedstawiciela Zleceniodawcy), najpóźniej do 1-ego dnia miesiąca następującego po miesiącu kalendarzowym, którego ww. Zestawienie liczby godzin dotyczy. Jeżeli w danym miesiącu obowiązywania Umowy Usługi nie były wykonywane Zleceniobiorca wpisuje „0” w Zestawieniu liczby godzin.</li>
    <li>Zleceniodawca nie później niż w terminie 3 dni od otrzymania zestawienia liczby godzin potwierdza albo odmawia potwierdzenia liczby godzin świadczenia Usług. Informacja o potwierdzeniu albo odmowie potwierdzenia jest przekazywana Zleceniobiorcy za pośrednictwem poczty elektronicznej. Zleceniobiorca w terminie 3 dni od daty przekazania przez Zleceniodawcę odmowy potwierdzenia liczby godzin świadczenia Usług w danym miesiącu może wnieść reklamację do Zleceniodawcy, za pośrednictwem poczty elektronicznej lub pisemnie. W terminie 3 dni roboczych od daty otrzymania reklamacji Zleceniodawca informuje Zleceniobiorcę o sposobie rozpoznania reklamacji za pośrednictwem poczty elektronicznej lub w formie pisemnej</li>
    <li>Wynagrodzenie będzie wypłacone przez Zleceniodawcę na wskazany rachunek bankowy Zleceniobiorcy w terminie 21 dni od daty otrzymania prawidłowo wystawionej faktury VAT/faktury. Faktura VAT zostanie wystawiona dopiero po potwierdzeniu przez Zleceniodawcę przekazanego zestawienia liczby godzin albo uznania reklamacji, o której mowa w punkcie powyżej, za zasadną.</li>
    <li>Za dzień zapłaty wynagrodzenia uważa się dzień obciążenia rachunku bankowego Zleceniodawcy.</li>
  </ol>

<p align="center" style="margin-bottom: 0px; margin-top: 5px;">
  <strong>§ 4 Świadczenia dodatkowe</strong>
</p>
<ol>
  <li>Strony zgodnie ustalają, że Zleceniobiorca może otrzymać dodatkowe wynagrodzenie w postaci premii, prowizji lub nagrody, na zasadach obowiązujących u Zleceniodawcy. Informacja o zasadach dodatkowego wynagrodzenia będzie przekazywana Zleceniobiorcy przez Zleceniodawcę pisemnie lub za pośrednictwem poczty elektronicznej. W szczególności dodatkowe wynagrodzenie może zostać przyznane za realizację wyznaczonych przez Zleceniodawcę celów budżetowych/jakościowych.</li>
  <li>Zleceniodawca oświadcza, a Zleceniobiorca akceptuje, że warunkiem wypłaty dodatkowego wynagrodzenia jest bezwzględne przestrzeganie przez Zleceniobiorcę zasad compliance obowiązujących u Zleceniodawcy. Jakiekolwiek, chociażby jednorazowe naruszenie tych zasad może skutkować pozbawieniem Zleceniobiorcy dodatkowego wynagrodzenia.</li>
  <li>Obowiązek zapłaty wynagrodzenia oraz ewentualnych świadczeń dodatkowych      z zastrzeżeniem      pkt. 4 poniżej stanowią całość zobowiązań Zleceniodawcy wobec Zleceniobiorcy z tytułu wykonania niniejszej Umowy, w czasie jej trwania jak również po jej rozwiązaniu lub wygaśnięciu.</li>
  <li>Zleceniodawca pokrywa koszty przejazdu pociągiem lub autobusem i noclegów Zleceniobiorcy, poza miejscem jego zamieszkania, związanych z wykonywaniem Usług, pod warunkiem ich wcześniejszej akceptacji przez Zleceniodawcę. Rozliczenie ww. kosztów następuje pod warunkiem dostarczenia Zleceniodawcy dokumentów potwierdzających fakt ich poniesienia przez Zleceniobiorcę w terminie do 7 dni od poniesienia takich kosztów.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 5 Klauzula poufności</strong>
</p>
<ol>
  <li>Zleceniobiorca jest zobowiązany do zachowania w poufności wszelkich informacji, jak również wszelkich dokumentów i projektów dokumentów ujawnionych przez Zleceniodawcę lub opracowanych przez Strony lub do których Zleceniobiorca będzie miał dostęp w trakcie podejmowanych czynności w związku z realizacją niniejszej Umową, zarówno przed, jak i po wejściu w życie Umowy, a które:
    <ol type="a">
      <li>dotyczą Umowy lub Zleceniodawcy, klientów Zleceniodawcy oraz jego działalności, w szczególności wszelkich informacji o charakterze ekonomicznym, handlowym lub organizacyjnym, jak również informacji odnoszących się do jego strategii, personelu i spraw finansowych lub przyszłych planów lub perspektyw, itp. oraz</li>
      <li>które nie zostały podane do publicznej wiadomości, oraz</li>
      <li>które Zleceniobiorca uzyskał lub które staną mu się znane w czasie obowiązywania niniejszej Umowy, a także przed podpisaniem niniejszej Umowy,</li>
    </ol>
    niezależnie od tego, czy informacje te są w formie pisemnej, ustnej czy w jakiejkolwiek innej formie, jak również niezależnie od tego, czy informacje te, wiedza lub dokumenty są wyraźnie oznaczone, jako poufne (zwane dalej: „Informacjami Poufnymi”). Nie dotyczy to informacji, do których ujawnienia Zleceniobiorca zobowiązany zostanie na mocy przepisów prawa.
  </li>
  <li>Obowiązek dochowania tajemnicy trwa w okresie obowiązywania niniejszej Umowy, a także przez okres 5 lat po rozwiązaniu lub wygaśnięciu niniejszej umowy.</li>
  <li>O ile Zleceniodawca nie wskaże inaczej, wyłączne prawo własności wobec wszelkich dokumentów oraz innych nośników informacji poufnych przysługuje Zleceniodawcy, co Zleceniobiorca niniejszym uznaje.</li>
  <li>Informacje Poufne ujawnione przez Zleceniodawcę w okresie obowiązywania niniejszej Umowy lub do których Zleceniobiorca będzie miał dostęp w związku z podejmowanymi czynnościami dotyczącymi realizacji Umowy, będą wykorzystywane wyłącznie w zakresie bezpośrednio związanym z realizacją Umowy. Zleceniobiorca nie jest upoważniony do wykorzystywania Informacji Poufnych w celu prowadzenia własnej działalności gospodarczej lub działalności podmiotów trzecich.</li>
  <li>Po rozwiązaniu niniejszej umowy Zleceniobiorca zobowiązany jest niezwłocznie przekazać Zleceniodawcy znajdujące się w jego posiadaniu: wszystkie pisma, całą korespondencję, projekty oraz wszelkie inne dokumenty dotyczące spraw Zleceniodawcy. Obowiązek zwrotu obejmuje także kopie powyższych dokumentów.</li>
  <li>Ponadto Zleceniobiorca zobowiązany jest po rozwiązaniu umowy  do usunięcia będących w jego posiadaniu lub pod jego kontrolą wszystkich cyfrowych wersji i kopii (włączając w to oryginały)  notatek, wiadomości e-mail, raportów, analiz, podsumowań, dokumentacji projektowej itp., które zawierają lub odzwierciedlają jakiekolwiek informacje poufne Zleceniodawcy lub jego klientów, bez zachowywania jakichkolwiek kopii; a także do trwałego (nieodwołalnego) wymazania i zniszczenia wszelkich materiałów zawierających lub odzwierciedlających jakiekolwiek poufne informacje Zleceniodawcy lub jego klientów, które są przechowywane na dowolnym komputerze lub innym urządzeniu będącym w posiadaniu lub pod kontrolą Zleceniobiorcy.</li>
  <li>Powyższe zobowiązanie dotyczy także usunięcia wszelkich kopii, reprodukcji oraz innych danych wygenerowanych przez Zleceniobiorcę w wyniku otrzymania informacji poufnych, o których mowa powyżej.</li>
  <li>Obowiązki określone w ust. 1- 7 powyżej odnoszą się także do Informacji Poufnych dotyczących potencjalnych klientów Zleceniodawcy, tj. podmiotów, z którymi Zleceniodawca prowadzi negocjacje w celu zawarcia umowy. Dla usunięcia wątpliwości przez prowadzenie negocjacji Strony rozumieją wszelkie czynności podejmowane przez Zleceniodawcę w celu zawarcia umowy, w tym składanie ofert za pośrednictwem Zleceniobiorcy.</li>
  <li>Klauzula poufności nie dotyczy informacji ujawnionych na żądanie uprawnionych organów w oparciu o obowiązujące przepisy prawa, informacji które są jawne, bądź zostały podane do publicznej wiadomości przez którąkolwiek ze Stron, za pisemną zgodą drugiej Strony.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
      <strong>§ 6 Zakaz konkurencji</strong>
    </p>
    <ol>
      <li>
        Zleceniobiorca jest zobowiązany do powstrzymania się od podejmowania i wykonywania działalności konkurencyjnej wobec Zleceniodawcy, w czasie obowiązywania niniejszej Umowy - zgodnie z definicją opisaną w niniejszym paragrafie.
        </li>
        <li>
          Postanowienia dotyczące zakazu konkurencji, Strony określają szczegółowo w dalszej części niniejszego paragrafu. 
      </li>
      <li>
        Za działalność konkurencyjną w rozumieniu niniejszego paragrafu Strony uznają oferowanie lub świadczenie przez Zleceniobiorcę, na jakiejkolwiek podstawie lub formie, usług edukacyjnych podobnych do usług oferowanych przez Zleceniodawcę, na rzecz klientów Zleceniodawcy, którzy zawarli ze Zleceniodawcą umowę najpóźniej w dniu wygaśnięcia albo rozwiązania niniejszej umowy.
      </li>
      <li>
        Za działalność konkurencyjną uznaje się również:
        <ol type="a">
          <li>
            świadczenie przez Zleceniobiorcę pracy na rzecz podmiotu prowadzącego działalność konkurencyjną wobec Zleceniodawcy (zgodnie z definicją zawartą w ust. 5 niniejszego paragrafu), w tym świadczenie usług na rzecz takich podmiotów na podstawie jakiejkolwiek innej umowy cywilnoprawnej,
          </li>
          <li>
            prowadzenie przez Zleceniobiorcę działalności konkurencyjnej, zgodnie z definicją opisaną w ust. 3, wobec Zleceniodawcy, także za pośrednictwem osób trzecich,
          </li>
          <li>
            bycie wspólnikiem lub członkiem organów spółki prowadzącej działalność konkurencyjną wobec Zleceniodawcy, zgodnie z definicją opisaną w ust. 5,
          </li>
          <li>
            pełnienie funkcji agenta, pełnomocnika lub prokurenta w podmiotach prowadzących działalność konkurencyjną wobec Zleceniodawcy, zgodnie z definicją opisaną w ust. 5.
          </li>
        </ol>
      </li>
      <li>
        Za podmiot prowadzący działalność konkurencyjną wobec Zleceniodawcy uznaje się każdy podmiot, który prowadzi działalność o tożsamym  charakterze do działalności prowadzonej przez Zleceniodawcę, wykorzystując te same lub podobne technologie, które nie są ogólnodostępne (tj. nie są powszechnie znane), oraz działa w oparciu o zbliżony model biznesowy do modelu Zleceniodawcy. Konkurencyjność tych podmiotów polega na tym, że oferują one usługi lub produkty edukacyjne, które mogą być bezpośrednią alternatywą dla usług oferowanych przez Zleceniodawcę, lub mają na celu pozyskanie tych samych klientów, korzystając z podobnych technologii i struktur organizacyjnych.
      </li>
      <li>
        Zleceniobiorca zobowiązuje się, że po wygaśnięciu albo rozwiązaniu niniejszej umowy nie będzie wykorzystywał materiałów, które zostały udostępnione mu przez Zleceniodawcę w trakcie współpracy.
      </li>
      <li>
        W przypadku, gdy w czasie obowiązywania niniejszej Umowy klient Zleceniodawcy złoży Zleceniobiorcy propozycję współpracy, Zleceniobiorca zobowiązany jest poinformować klienta o obowiązującym go zakazie konkurencji i odmówić podjęcia współpracy. Zleceniobiorca ma również obowiązek niezwłocznie poinformować Zleceniodawcę o zaistniałej sytuacji.
      </li>
      <li>
        Zleceniodawca zastrzega sobie prawo do weryfikacji przestrzegania przez Zleceniobiorcę postanowień niniejszego paragrafu.
      </li>
      <li>
        W przypadku naruszenia zakazu konkurencji, Zleceniobiorca zobowiązany jest do zapłaty Zleceniodawcy kary umownej w wysokości 20 000,00 zł (słownie: dwadzieścia tysięcy złotych) za każdy przypadek naruszenia. Zleceniodawcy przysługuje również prawo do dochodzenia odszkodowania na zasadach ogólnych, w wysokości przewyższającej zapłaconą karę umowną.
      </li>
    </ol>
    <br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 7 Kara umowna</strong>
</p>
<ol>
  <li>Zleceniobiorca zapłaci na rzecz Zleceniodawcy karę umowną, w kwocie 50.000 zł (pięćdziesiąt tysięcy złotych), w przypadku:
    <ol type="a">
      <li>świadczenia usług na rzecz podmiotów konkurencyjnych w stosunku do Zleceniodawcy, tj. naruszenia § 6 umowy.</li>
      <li>naruszenia klauzuli poufności o której mowa w § 5 umowy,</li>
    </ol>
  </li>
  <li>Zapłata kary umownej przez Zleceniobiorcę nastąpi w terminie 14 dni od dnia wezwanie do zapłaty, na rachunek bankowy wskazany przez Zleceniodawcę.</li>
  <li>W przypadku wystąpienia szkody przewyższającej zastrzeżoną karę umowną, Zleceniodawcy przysługuje prawo dochodzenia odszkodowania na zasadach ogólnych.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 8 Czas trwania i rozwiązanie Umowy</strong>
</p>
  <ol>
    <li>Umowa zostaje zawarta na czas określony, począwszy od dnia xxxx do xxxxxxx.</li>
    <li>Zleceniodawcy oraz Zleceniobiorcy przysługuje prawo wypowiedzenia Umowy w każdym czasie, bez podania przyczyny, z zachowaniem 5-cio dniowego okresu wypowiedzenia, z tym zastrzeżeniem, że jeżeli Umowa zawarta jest na okres krótszy niż jeden miesiąc, okres wypowiedzenia wynosi 7 dni. Oświadczenie o wypowiedzeniu umowy wymaga zachowania formy pisemnej.</li>
    <li>Zleceniodawca może rozwiązać niniejszą umowę ze skutkiem natychmiastowym, w przypadku:
      <ol type="a">
        <li>niewykonywania lub nienależytego wykonywania przez Zleceniobiorcę usług objętych niniejszą umową,</li>
        <li>dopuszczenia się przez Zleceniobiorcę naruszenia postanowień § 5 lub 6 niniejszej Umowy,</li>
        <li>dopuszczenia się przez Zleceniobiorcę uporczywego lub rażącego naruszenia postanowień niniejszej Umowy, innych niż wskazane w § 5 lub 6 Umowy, bądź właściwych przepisów prawa, przy czym w takim wypadku Zleceniodawca obowiązany jest wskazać Zleceniobiorcy w formie pisemnej jasne i szczegółowe wyjaśnienie powstałych naruszeń i uzasadnić tym samym podstawę rozwiązania Umowy.</li>
      </ol>
    </li>
    <li>Zleceniobiorca może rozwiązać niniejszą umowę ze skutkiem natychmiastowym w przypadku pozostawania przez Zleceniodawcę w zwłoce z zapłatą wynagrodzenia przez okres dłuższy niż 30 dni.</li>
    <li>Z chwilą rozwiązania lub wygaśnięcia Umowy, najpóźniej w ostatnim dniu obowiązywania Umowy, Zleceniobiorca zobowiązany jest zwrócić Zleceniodawcy wszelkie przekazane mu przez Zleceniodawcę na potrzeby realizacji Usług materiały, sprzęt i narzędzia, pod rygorem zapłaty kary umownej w wysokości 1 000 złotych za każdy rozpoczęty dzień opóźnienia lub zwłoki w realizacji ww. zobowiązania. Zleceniodawca jest uprawniony do dochodzenia odszkodowania przewyższającego wysokość kary umownej. </li>
  </ol>
  <br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 9 Prawa autorskie i pokrewne</strong>
</p>
<ol>
  <li>Zleceniobiorca przenosi na Zleceniodawcę, z chwilą ich wytworzenia, wszelkie prawa autorskie i prawa własności intelektualnej do utworów, w tym w szczególności autorskie prawa majątkowe do utworów wytworzonych w wyniku wykonywania usług i wszelkich ich elementów (dalej: „Utwory”), a w szczególności prawo do korzystania oraz rozporządzania nimi, bez jakichkolwiek ograniczeń czasowych, ilościowych i terytorialnych, na cały okres trwania tych praw, na następujących polach eksploatacji:
    <ol type="a">
      <li>w zakresie trwałego lub czasowego utrwalania i zwielokrotniania utworów w całości lub w części, jakimikolwiek środkami i w jakiejkolwiek formie, w tym w zakresie niezbędnym dla wprowadzania, wyświetlania, stosowania, przekazywania i przechowywania utworów;</li>
      <li>tłumaczenia, przystosowywania, zmiany układu lub jakichkolwiek innych zmian utworów lub jego elementów;</li>
      <li>w zakresie rozpowszechniania utworów i ich elementów, w tym użyczenia lub najmu, w szczególności poprzez publiczne ich udostępnianie w taki sposób, aby każdy mógł mieć do nich dostęp w miejscu i w czasie przez siebie wybranym, w szczególności w sieciach komputerowych, Internecie i Intranecie.</li>
    </ol>
  </li>
  <li>Jednocześnie Zleceniobiorca wyraża zgodę i upoważnia Zleceniodawcę i jego następców prawnych do:
    <ol type="a">
      <li>dokonywania wszelkich przeróbek, skrótów, aktualizacji i zmian utworów i ich poszczególnych elementów, w tym kodu źródłowego;</li>
      <li>wykorzystywania utworów i ich poszczególnych elementów, w dowolnych częściach lub w całości, w tym w innych utworach i w połączeniu z innymi materiałami, w szczególności w postaci prezentacji multimedialnych;</li>
      <li>wykorzystywania utworów i ich poszczególnych elementów, w jakimkolwiek charakterze i celu;</li>
      <li>samodzielnego rozpowszechniania oraz zezwalania na rozpowszechnianie i korzystanie z opracowań utworów i ich poszczególnych elementów stworzonych zgodnie z pkt. (a) - (c) powyżej;</li>
      <li>samodzielnego zgłaszania i rejestrowania, na swoją rzecz, utworów i ich poszczególnych elementów oraz opracowań zgodnie z obowiązującymi przepisami z zakresu ochrony własności przemysłowej.</li>
    </ol>
  </li>
  <li>W powyższym zakresie Zleceniobiorca rezygnuje z wykonywania wobec Zleceniodawcy i jego następców prawnych autorskich praw osobistych i zobowiązuje się uzyskać na to stosowną zgodę uprawnionych w tym zakresie osób, które wniosły wkład twórczy w utwory.</li>
  <li>Przeniesienie praw, o których mowa powyżej, dotyczy zarówno utworów w ich finalnej wersji, jak również wszelkich elementów utworów, we wszystkich wersjach i stadiach pośrednich, w tym kodu źródłowego i dokumentacji.</li>
  <li>Zleceniobiorca oświadcza, że wyraża zgodę na włączenie utworów (w całości lub w części) do innego utworu, w tym audiowizualnego, multimedialnego i audialnego lub też do połączenia z takim utworem.</li>
  <li>W powyższym zakresie Zleceniobiorca rezygnuje z wykonywania wobec Zleceniodawcy i jego następców prawnych praw osobistych do utworów oraz upoważnia Zleceniodawcę do udostępniania i rozpowszechniania utworów bez oznaczania jego imienia i nazwiska.</li>
  <li>Zleceniobiorca upoważnia Zleceniodawcę do wykonywania w jego imieniu i jednocześnie zobowiązuje się do nie wykonywania wobec Zleceniodawcy oraz osób trzecich, którym Zleceniodawca zezwoli na korzystanie z utworów swoich autorskich praw osobistych, a w szczególności prawa do autorstwa utworu oraz oznaczania utworu swoim nazwiskiem lub pseudonimem albo do udostępniania go anonimowo. Zleceniobiorca zobowiązuje się naprawić Zleceniodawcy wszystkie szkody i koszty poniesione wskutek działań lub zaniechań Zleceniobiorcy niezgodnych z niniejszym postanowieniem.</li>
  <li>Zleceniobiorca zrzeka się prawa wykonywania nadzoru autorskiego.</li>
  <li>Zleceniodawcy przysługuje prawo do przenoszenia nabytych na mocy niniejszej Umowy praw, w całości lub w części, oraz udzielenia licencji na osoby trzecie bez konieczności zapłaty jakiegokolwiek dodatkowego wynagrodzenia na rzecz Zleceniobiorcy i bez konieczności uzyskiwania jego odrębnej zgody.</li>
  <li>Zleceniodawca samodzielnie ustala sposób, formę, miejsce i termin eksploatacji utworów. Zleceniodawca może korzystać z utworów w całości lub w dowolnie przez siebie wybranych fragmentach.</li>
  <li>Zleceniodawca nabywa, z chwilą przyjęcia utworów, własność dostarczonych przez Zleceniobiorcę egzemplarzy utworów i nośników, na których przekazuje on Zleceniodawcy utwory.</li>
  <li>Postanowienia niniejszego paragrafu stosuje się do całości utworów, jak i do jego poszczególnych, dających się wyodrębnić, elementów.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 10 Postanowienia dodatkowe</strong>
</p>
  <ol>
    <li>Zleceniobiorca oświadcza, że został zapoznany z przepisami BHP, zagrożeniami związanymi ze świadczonymi Usługami oraz zasadami ochrony przeciwpożarowej w zakresie instruktażu ogólnego i stanowiskowego BHP. Zleceniobiorca zobowiązuje się do przestrzegania tych zasad niezależnie od miejsca wykonywania pracy.Zleceniobiorca oświadcza, że jego stan zdrowia pozwala na świadczenie Usług objętych Umową.</li>
    <li>Zleceniodawca wyraża zgodę na korzystanie przez Zleceniobiorcę wyłącznie w okresie obowiązywania niniejszej Umowy z oznaczenia graficznego TUTORE w celu realizacji niniejszej Umowy. Celem uniknięcia wątpliwości Strony ustalają, że Zleceniobiorca może korzystać wyłącznie ze znaku graficznego, wyłącznie celach biznesowych i promocyjnych Zleceniodawcy. Zleceniodawca może udzielać takiego upoważnienia innym osobom oraz podmiotom. Zleceniobiorca nie jest uprawniony do udzielania upoważnienia do korzystania ze znaku innym podmiotom ani osobom. Zleceniobiorca nie jest uprawniony do dokonywania jakichkolwiek zmian czy przeróbek znaku.</li>
    <li>Zasady powierzenia Zleceniobiorcy przetwarzania danych osobowych klientów Zleceniodawcy reguluje Załącznik nr 3 do niniejszej Umowy.</li>
  </ol>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 11 Klauzula antykorupcyjna</strong>
</p>
  <ol>
    <li>Zleceniobiorca przyjmuje do wiadomości, że jedną z zasad działalności Zleceniodawcy jest przestrzeganie zakazu bezpośredniego lub pośredniego przekazywania jakichkolwiek korzyści majątkowych osobom pełniącym funkcje publiczne lub instytucjom publicznym i państwowym, w celu uzyskania lub utrzymania korzyści handlowych i zobowiązuje się do przestrzegania tej zasady.</li>
    <li>Zleceniobiorca przyjmuje do wiadomości, że stosowne przepisy prawa zabraniają, m.in. bezpośredniego lub pośredniego przekazywania korzyści majątkowych lub osobistych funkcjonariuszom publicznym, osobom pełniącym funkcje publiczne oraz innym urzędnikom państwowym, a także partiom politycznym lub ich kandydatom w celu uzyskania lub utrzymania korzyści biznesowych i zobowiązuje się przestrzegać te zasady.</li>
    <li>Zleceniobiorca zobowiązuje się przestrzegać zasad opisanych powyżej, w tym oświadcza, że wynagrodzenie, o którym mowa w § 4 niniejszej Umowy, jest świadczeniem ekwiwalentnym w stosunku do świadczeń wykonanych przez Zleceniobiorcę na podstawie Umowy i nie narusza zasad opisanych w ustępach poprzedzających.</li>
    <li>Zleceniobiorca oświadcza, że nie pozostaje w żadnej relacji służbowej lub osobistej, która mogłaby powodować podejrzenie, że zawarcie Umowy będzie sprzeczne z opisanymi powyżej zasadami. W przypadku podejrzenia zaistnienia takiej relacji, Zleceniobiorca zobowiązuje się niezwłocznie powiadomić o tym fakcie Zleceniodawcę. W takim przypadku Zleceniodawcy przysługuje prawo do natychmiastowego rozwiązania Umowy.</li>
  </ol>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 12 Klauzula salwatoryjna</strong>
</p>
<p>Jeżeli którekolwiek z postanowień Umowy lub jego część okaże się nieważne, pozostałe postanowienia Umowy pozostają w mocy, a Strony zobowiązują się na wniosek którejkolwiek z nich do zastąpienia tych nieważnych postanowień lub ich części mającymi moc prawną i skutek ekonomiczny postanowieniami możliwie najbardziej zbliżonymi do zastępowanego postanowienia lub jego części.</p>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 13 Postanowienia końcowe</strong>
</p>
  <ol>
    <li>Zmiana lub uzupełnienie niniejszej umowy wymaga formy pisemnej pod rygorem nieważności.</li>
    <li>W sprawach nieuregulowanych niniejszą umową odpowiednie zastosowanie mają przepisy prawa w tym Kodeksu cywilnego.</li>
    <li>W przypadku stwierdzenia, iż niniejsza Umowa, w części lub w całości, jest nieskuteczna prawnie z jakichkolwiek powodów, strony zobowiązują się do dokonania takich zmian jej treści, by nieskuteczność ową usunąć.</li>
    <li>Wszelkie spory wynikające z niniejszej Umowy lub z nią związane będą rozstrzygane na drodze polubownej, a w przypadku braku porozumienia pomiędzy stronami zostaną poddane rozstrzygnięciu przez sąd powszechny właściwy dla siedziby Zleceniodawcy.</li>
    <li>Umowę sporządzono w dwóch jednobrzmiących egzemplarzach po jednym dla każdej ze Stron.</li>
    <li>Integralną część Umowy stanowią:</li>
  </ol>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 11 Ilość umów</strong>
</p>
<p>Umowę sporządzono w dwóch jednobrzmiących egzemplarzach, po jednym dla każdej ze stron.</p>
<br>
<br>

 <div>
  <p class="underline"><b>Załączniki stanowiące integralną część umowy:</b></p>
  <ol>
    <li class="underline">Zgoda na wykorzystanie wizerunku</li>
    <li class="underline">Klauzula informacyjna RODO</li>
    <li class="underline">Upoważnienie do przetwarzania danych osobowych</li>
    <li class="underline">Informacja o monitoringu zajęć on - line</li>
    <li 
			v-if="zamawiajacy.includes('Ewa Szcześniewska')"
			class="underline"
		>
			Kopia pełnomocnictwa
		</li>
  </ol>
</div>

<div class="cointainer" style="margin-top: 30px; margin-bottom: 30px;">
    <div class="left-cointainer">
        <span><b>{{ zamawiajacy }}</b></span>
        <br>
        <p><b>Podpis Zleceniodawcy</b></p>
    </div>
    <div class="right-cointainer">
        {{ imieNazwisko }}
        <br>
        <span style="margin-left: 0%;"><b>Zleceniobiorca</b></span>
    </div>
</div>

 <div style="margin-top:5px;page-break-before: always;">
   <p class="underline">Załącznik nr 1</p>
   <p align="center" style="margin-top: 40px;"><strong>INFORMACJA O PRZETWARZANIU DANYCH OSOBOWYCH OBEJMUJĄCYCH WIZERUNEK PRACOWNIKÓW/ZLECENIOBIORCÓW</strong></p>
   <p>Tutore Poland Sp. z o.o., nazywana dalej Spółką, zamierza wykorzystywać wizerunek pracowników i zleceniobiorców w celach marketingowych obejmujących: umieszczenie na stronach internetowych należących do marek Spółki, zamieszczenie w materiałach promocyjnych Spółki (np. ulotki, katalogi), zamieszczenie w materiałach informacyjnych Spółki, umieszczenie na łamach firmowych mediów społecznościowych (m.in. FB, Instagram) oraz w ramach prowadzonych kanałów video (Youtube). Na podstawie art. 6 ust. 1 lit. a RODO, przetwarzanie przez Spółkę wizerunku pracowników/zleceniobiorców dla opisanych celów marketingowych wymaga wyrażenia zgody przez osoby fizyczne, których dane są przetwarzane.</p>
  </div>
  <div style="page-break-before: always">
    <p align="center"><strong>KLAUZULA INFORMACYJNA Tutore Poland Sp. z o.o.</strong></p>
    <p>Na podstawie art. 13 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO, poniżej zamieszczamy informacje dotyczące przetwarzania danych osobowych w postaci wizerunku pracowników/zleceniobiorców przez Tutore Poland Sp. z o.o., dalej ADO:
			<ol>
			<li>Administratorem Danych Osobowych jest Tutore Poland Sp. z o.o. z siedzibą przy ul. Piotrkowska 157A, 90-440 Łódź, tel.  500 965 135</li>
			<li>ADO przetwarza dane osobowe w postaci wizerunku w celach marketingowych opisanych w Informacji o przetwarzaniu danych osobowych obejmujących wizerunek pracowników/zleceniobiorców na podstawie wyrażonej zgody (Art. 6 ust. 1 lit. a RODO).</li>
			<li>Odbiorcami danych osobowych mogą być podmioty świadczące usługi informatyczne i wsparcia www oraz przygotowujące kampanie i materiały promocyjne (agencje reklamowe, agencje interaktywne), podmioty prasowe.</li>
			<li>ADO nie przekazuje danych osobowych poza Europejski Obszar Gospodarczy.</li>
			<li>Dane osobowe przechowywane będą przez okres niezbędny dla realizacji celów określonych w pkt 2 lub do czasu cofnięcia zgody przez zleceniobiorcę.</li>
			<li>Osoba której dane są przetwarzane ma prawo dostępu do swoich danych oraz otrzymania ich kopii, prawo do sprostowania (poprawiania) swoich danych, prawo do ograniczenia przetwarzania, prawo do bycia zapomnianym, prawo do sprzeciwu, prawo do przenoszenia danych, prawo do cofnięcia udzielonej zgody w każdym czasie, prawo do wniesienia skargi do Urzędu Ochrony Danych Osobowych.</li>
			<li>Podanie danych osobowych jest całkowicie dobrowolne.</li>
			<li>W ramach działalności ADO nie dochodzi do zautomatyzowanego podejmowania decyzji, w tym profilowania, z wykorzystaniem zebranych danych osobowych.</li>
		</ol>
   </p>
  </div>
   

<div class="container" style="page-break-before: always;">
    <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
      <tr>
        <td id="oswiadczenie">
          <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY ZE ZGODĄ NA PRZETWARZANIE DANYCH OSOBOWYCH</strong></p>
          <ol>
        <li>Ja niżej podpisany/a {{ imieNazwisko }} oświadczam, iż:
        <ol type="a">
          <li>
            zapoznałem/am się z Informacją o przetwarzaniu danych osobowych obejmujących wizerunek pracowników/zleceniobiorców oraz Klauzulą informacyjną i przyjmuję ją do wiadomości,
          </li>
          <li>
            treść Informacji i Klauzuli jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną z Tutore Poland Sp. z o.o., w sposób wyczerpujący,
          </li>
        </ol>
        </li>
        <li>W sposób całkowicie dobrowolny, wyrażam zgodę na przetwarzanie moich danych osobowych w zakresie mojego wizerunku dla opisanych wyżej celów marketingowych.</li>
        <li>Zostałem/am poinformowany/a, że moje dane osobowe przetwarzane są na podstawie wyrażonej przeze mnie dobrowolnej zgody oraz, że przysługuje mi prawo do jej cofnięcia w każdym czasie, przy czym cofnięcie zgody wywołuje skutki prawne od momentu jego złożenia i będzie pozostawało bez wpływu na przetwarzanie moich danych osobowych przed złożeniem oświadczenia o cofnięciu zgody.</li>
        <li>W trybie art. 81 ust.1 ustawy o prawie autorskim i prawach pokrewnych wyrażam zgodę na rozpowszechnianie mojego wizerunku przez Tutore Poland Sp. z o.o., dla celów marketingowych opisanych powyżej.</li>
        </ol>
          <div class="right-cointainer" style="float: right; margin-top: 20px;">
            <span style="font-size: 14px;">{{ imieNazwisko }}</span>
            <br>
            <span><strong>czytelny podpis Zleceniobiorcy</strong></span>
          </div>
      </td>
    </tr>
  </table>
  </div>

<div style="page-break-before: always;">
  <p><strong>Załącznik 2</strong></p>
  <p align="center"><strong>INFORMACJA O PRZETWARZANIU DANYCH OSOBOWYCH</strong></p>
  <ol>
  <li>Informuję, że Administratorem danych osobowych Pani/Pana jako Zleceniobiorcy jest Tutore Poland Sp. z o.o. z siedzibą przy ul. Piotrkowska 157A, 90-440 Łódź, KRS: 0000670834, NIP: 7272812193, tel. 500 965 135, info@tutore.eu.</li>
  <li>Przedstawiając Pani/Panu niniejszą informację o przetwarzaniu danych osobowych Administrator spełnia obowiązek prawny wynikający z art. 15 ust. 1 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO.</li>
  <li>Administrator pozyskuje informacje o Pani/Panu w związku z obowiązkiem ustawowym, co jest niezbędne do skutecznej realizacji procesu współpracy. W zakresie danych osobowych nie dotkniętych ustawowym warunkiem niezbędności – ich podanie jest dobrowolne.</li>
  <li>Pani/Pana dane osobowe przetwarzane są w następujących celach, na następującej podstawie i w następującym okresie:
    <ol>
      <li>zawarcia oraz realizacji umowy cywilnoprawnej – w celu realizacji obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1 lit. b, c, f RODO) – przez okres współpracy,</li>
      <li>wyliczenia i wypłaty wynagrodzenia – w celu realizacji obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit. b RODO) – przez okres współpracy,</li>
      <li>potrąceń z wynagrodzenia – w celu realizacji obowiązków w zakresie egzekucji z wynagrodzenia wynikających z kodeksu postępowania cywilnego, ustawy o postępowaniu egzekucyjnym w administracji, ustawy o komornikach sądowych (art. 6 ust. 1 lit. c RODO) – przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa,</li>
      <li>realizacji obowiązków podatkowych – w celu realizacji obowiązków płatnika podatku dochodowego wynikających z ordynacji podatkowej, ustawy o podatku dochodowym od osób fizycznych i innych przepisów podatkowych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku kalendarzowego,</li>
      <li>realizacji obowiązków wobec ZUS – w celu realizacji obowiązków płatnika składek na ubezpieczenie społeczne i zdrowotne wynikających z ustawy o emeryturach i rentach z Funduszu Ubezpieczeń Społecznych, ustawy o systemie ubezpieczeń społecznych oraz ustawy o świadczeniach opieki zdrowotnej finansowanych ze środków publicznych (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit b RODO) – przez okres 5 lat od końca roku kalendarzowego,</li>
      <li>realizacji obowiązków księgowych – w celu realizacji obowiązków wynikających z ustawy o rachunkowości, ordynacji podatkowej oraz ustawy o podatku dochodowym od osób prawnych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku rozliczeniowego, w którym nastąpiło zdarzenie,</li>
      <li>bezpieczeństwa fizycznego budynków, pomieszczeń oraz mienia Administratora – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) – przez okres współpracy,</li>
      <li>zapewnienia najwyższych standardów obsługi zajęć lekcyjnych realizowanych przez Współpracowników za pośrednictwem platformy ClickMeeting lub Zoom, prawidłowości wykonywania powierzonych czynności oraz ewentualnego poprawienia jakości lekcji, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy) poprzez monitoring i nagrywanie kursów online – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) – Wizerunek i głos Współpracownika będzie przetwarzany przez okres 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych zajęć stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Administrator powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu,</li>
      <li>zapewnienia możliwości udostępnienia nagrań nowym Pracownikom i Współpracownikom nagrywanie szkoleń online prowadzonych za pomocą platformy Zoom – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) - Wizerunek i głos Współpracownika będą przetwarzane do czasu wycofania zgody. W razie wycofania zgody nagrania zawierające dane osobowe, podlegają zniszczeniu,</li>
      <li>zapewnienia najwyższych standardów jakości obsługi klienta, w celu szkoleniowym – umożliwiającym poprawienie jakości obsługi, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy), zapewnienia bezpieczeństwa Współpracownikom w przypadku zdarzeń niepożądanych i niebezpiecznych ze strony Klientów (np. groźby karalne) poprzez monitoring rozmów telefonicznych z Klientami Administratora – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) - przez okres do 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych rozmów telefonicznych stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Administrator powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu,</li>
      <li>tworzenia fotorelacji z obozów dla dzieci i młodzieży na pendrive dla Klientów, fanpagu facebook i Witrynie internetowej www.musicandmore.pl – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) - Wizerunek i głos Współpracownika będą przetwarzane do czasu wycofania zgody. W razie wycofania zgody nagrania zawierające dane osobowe, podlegają zniszczeniu,</li>
      <li>dochodzenia roszczeń lub obrony przed roszczeniami – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) polegającego na występowaniu w sprawach sądowych – w przypadku toczącego się postępowania przez okres trwania postępowania do czasu jego prawomocnego zakończenia oraz przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa.</li>
    </ol>
  </li>
  <li>Odbiorcami Pani/Pana danych osobowych będą:
    <ol>
      <li>organy administracji publicznej (np. Zakład Ubezpieczeń Społecznych, Urzędy Skarbowe) – na mocy odpowiednich przepisów prawa;</li>
      <li>zakłady opieki zdrowotnej w celach związanych z medycyną pracy;</li>
      <li>podmioty zewnętrzne dostarczające i wspierające systemy teleinformatyczne Zleceniodawcy (zarówno ogólną infrastrukturę teleinformatyczną, pocztę elektroniczną, jak i systemy informatyczne stosowane przez Zleceniodawcę w celu obsługi kadrowo-finansowej lub obiegu dokumentów związanych z zatrudnieniem) – na mocy stosownych umów powierzenia przetwarzania danych osobowych oraz przy zapewnieniu stosowania przez ww. podmioty adekwatnych środków technicznych i organizacyjnych zapewniających ochronę danych,</li>
      <li>biura księgowe:</li>
      <li>banki – w celu wypłaty wynagrodzeń i innych świadczeń pieniężnych na rzecz Zleceniodawcy w przypadku ich wypłaty za zgodą Zleceniobiorcy na rachunek bankowy;</li>
      <li>kontrahenci – w celu umożliwienia kontrahentom (potencjalnym oraz obecnym) kontaktu lub w celu bieżącej realizacji zawartych umów, a związanych z zajmowanym przez Zleceniobiorcę stanowiskiem pracy;</li>
      <li>współpracownicy Zleceniodawcy, którzy świadczą usługi na rzecz Tutore Poland Sp. z o.o., w celu umożliwienia współpracownikom kontaktu ze Zleceniobiorcą,</li>
      <li>podmioty świadczące dodatkowe usługi dla Zleceniobiorców, wyłącznie w przypadku korzystania przez Zleceniobiorcę z tych usług.</li>
      <li>instytucje ubezpieczeniowe</li>
      <li>organizacje administracji zagranicznej w krajach UE, w których realizowana jest umowa (dotyczy realizacji umowy za granicą)</li>
      <li>podmioty szkoleniowe i realizujące obowiązki BHP (jeśli nie ma komórki BHP u Zleceniodawcy)</li>
    </ol>
  </li>
  <li>Ma Pani/Pan prawo do:
    <ol>
      <li>dostępu do danych — uzyskania od Administratora potwierdzenia, czy przetwarzane są Pani/Pana dane osobowe. Jeżeli dane są przetwarzane, jest Pani/Pan uprawniona/y do uzyskania dostępu do nich (art. 15 RODO);</li>
      <li>otrzymania kopii danych — uzyskania kopii danych podlegających przetwarzaniu, przy czym pierwsza kopia jest bezpłatna, a za kolejne kopie właściwy Administrator może nałożyć opłatę w rozsądnej wysokości, wynikającą z kosztów administracyjnych (art. 15 ust. 3 RODO);</li>
      <li>sprostowania — żądania sprostowania danych osobowych, które są nieprawidłowe, lub uzupełnienia niekompletnych danych (art. 16 RODO);</li>
      <li>usunięcia danych — żądania usunięcia danych osobowych, jeżeli Administrator nie ma już podstawy prawnej do ich przetwarzania lub dane nie są już niezbędne do celów przetwarzania (art. 17 RODO);</li>
      <li>ograniczenia przetwarzania — żądania ograniczenia przetwarzania danych osobowych (art. 18 RODO), gdy:
        <ul>
          <li>kwestionuje Pani/Pan prawidłowość danych osobowych — na okres pozwalający Administratorowi sprawdzić prawidłowość tych danych,</li>
          <li>przetwarzanie jest niezgodne z prawem, a sprzeciwia się Pani/Pan ich usunięciu, żądając ograniczenia ich wykorzystywania,</li>
          <li>Administrator nie potrzebuje już tych danych, ale są one Pani/Panu do ustalenia, dochodzenia lub obrony roszczeń;</li>
          <li>wniosła Pani/wniósł Pan sprzeciw wobec przetwarzania — do czasu stwierdzenia, czy prawnie uzasadnione podstawy po stronie Administratora są nadrzędne wobec podstaw Pani/Pana sprzeciwu;</li>
        </ul>
      </li>
      <li>przenoszenia danych — otrzymania w ustrukturyzowanym, powszechnie używanym formacie nadającym się do odczytu maszynowego danych osobowych Pani/Pana dotyczących dostarczonych Administratorowi, oraz żądania przesłania tych danych innemu Administratorowi, jeżeli dane są przetwarzane na podstawie Pani/Pana zgody, lub umowy z Panią/Panem zawartej oraz jeżeli dane są przetwarzane w sposób zautomatyzowany (art. 20 RODO);</li>
      <li>sprzeciwu — wniesienia sprzeciwu wobec przetwarzania danych osobowych w prawnie uzasadnionych celach Administratora, z przyczyn związanych z Pani/Pana szczególną sytuacją, w tym wobec profilowania. Administrator dokonuje oceny istnienia ważnych prawnie uzasadnionych podstaw do przetwarzania, nadrzędnych wobec Pani/Pana interesów, praw i wolności lub podstaw do ustalenia, dochodzenia lub obrony roszczeń. Jeżeli zgodnie z oceną Pani/Pana interesy będą ważniejsze od interesów Administratora, Administrator będzie zobowiązany zaprzestać przetwarzania danych w tych celach (art. 21 RODO);</li>
      <li>prawo wniesienia skargi do organu nadzorczego – Prezesa Urzędu Ochrony Danych Osobowych, gdy uzna Pani/Pan, iż przetwarzanie danych osobowych Pani/Pana dotyczących narusza przepisy. Skargi można składać w formie:
        <ul>
          <li>pisemnej na adres: ul. Stawki 2, 00-193 Warszawa,</li>
          <li>elektronicznie za pośrednictwem platformy ePUAP.</li>
        </ul>
      </li>
    </ol>
  </li>
  <li>W trakcie przetwarzania danych osobowych nie dochodzi do wyłącznie zautomatyzowanego podejmowania decyzji ani do profilowania, o których mowa w art. 22 ust. 1 i 4 RODO, co oznacza, że żadne decyzje Pani/Pana dotyczące nie będą zapadać automatycznie oraz że nie będą tworzone żadne profile Pani/Pana dotyczące.</li>
  <li>Ma Pani/Pan obowiązek informowania Zleceniodawcy o wszelkich zmianach dotyczących Pani/Pana danych osobowych, przekazanych Zleceniodawcy zgodnie z Umową.</li>
  </ol>
  </div>

  <p align="center" style="margin-top: 50px;"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
  <ol>
    <li>Ja niżej podpisany/a oświadczam, iż:
      <ol>
        <li>zapoznałem/am się z Informacją o przetwarzaniu moich danych osobowych i przyjmuję ją do wiadomości,</li>
        <li>treść Informacji jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący.</li>
      </ol>
    </li>
  </ol>
  <div class="right-cointainer" style="float: right; margin-top: 20px;">
    <span style="font-size: 14px;">{{ imieNazwisko }}</span>
    <br>
    <span><strong>czytelny podpis Zleceniobiorcy</strong></span>
  </div>

<div style="page-break-before: always;">
  <div class="cointainer" style="margin-top: 60px;">
    <div class="left-cointainer">
      <p class="underline">Załącznik nr 3 Upoważnienie do przetwarzania danych osobowych</p>
    </div>
    <div class="right-cointainer">
      <p style="margin-bottom: 10px; font-size: 14px;">
    Łódź, dnia {{ aktualnaData() }} r.
      </p>
    </div>
</div>
  
  
<p align="center" class="subheading" style="margin-bottom: 10px;">
  <strong>
    Upoważnienie nr {{ nrUmowy }} do przetwarzania danych osobowych w zbiorze w wersji papierowej i elektronicznej
  </strong>
</p>
<p class="p-margin">
  Na podstawie art. 29 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO, niniejszym:
</p>
<p class="p-margin">
  z dniem {{ aktualnaData() }}
</p>
<p class="p-margin">
  upoważniam Pana/Panią {{ imieNazwisko }} - Tutore Poland Sp. z o.o.
</p>
<p class="p-margin">
  do przetwarzania danych osobowych zawartych w poniżej wymienionych zbiorach danych osobowych:
</p>
  <ol type="a">
    <li>w wersji elektronicznej:
      <ul>
        <li>
          zbiór danych osobowych Uczestników: dzieci, młodzieży i dorosłych korzystających z usług prowadzonych przez Tutore Poland Sp. z o.o. - imię i nazwisko, klasa (jeśli dotyczy), adres zamieszkania,
        </li>
        <li>
          zbiór danych osobowych Klientów: rodziców (opiekunów prawnych) dzieci, młodzieży i dorosłych korzystających z usług oferowanych przez Tutore Poland Sp. z o.o. – imię i nazwisko, adres zamieszkania, telefon kontaktowy, adres e-mail
        </li>
      </ul>
    </li>
  </ol>
<p class="p-margin">
  w zakresie wglądu, wprowadzania, modyfikacji, usuwania i archiwizacji danych osobowych objętych wyżej wymienionymi zbiorami.
</p>
<p class="p-margin">
  Niniejsze  upoważnienie  nie  upoważnia  do  udzielania  dalszych  upoważnień  i  wygasa  z  dniem ustania stosunku pracy, a ponadto może być w każdym czasie zmienione lub odwołane.
</p>
<p>
  Zobowiązuję Pana/Panią do przetwarzania danych osobowych  zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Pracodawcy - Administratora Danych Osobowych. Zobowiązuję Pana/Panią do przetwarzania danych osobowych  zgodnie z udzielonym upoważnieniem, rozporządzeniem Parlamentu Europejskiego i Rady (UE)2016/679 z 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych  oraz uchylenia dyrektywy 95/46/WE ( Dz. Urz. UE L 119, s.1) oraz przepisami ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (Dz.U. z 2018 r. poz.1000) i obowiązującymi w Tutore Poland Sp. z o.o.. wewnętrznymi regulacjami w sprawie ochrony danych osobowych.
  <br>
  Naruszenie ww. obowiązków  może skutkować  poniesieniem  odpowiedzialności karnej oraz stanowi podstawę do rozwiązania umowy o pracę.
</p>

<div class="container" style="page-break-before: always;">
    <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
      <tr>
        <td id="oswiadczenie">
          <p align="center" class="subheading"><strong>OŚWIADCZENIE</strong></p>
          <ol>
        <li>Ja niżej podpisany/a oświadczam, iż:
        <ol type="a">
          <li>
            zapoznałem/am się z treścią i zakresem upoważnienia i przyjmuję je do wiadomości,
          </li>
          <li>
            treść upoważnienia jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący,
          </li>
          <li>zobowiązuję się do przetwarzania danych osobowych  zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Pracodawcy,</li>
          <li>zobowiązuję się do przetwarzania danych osobowych  zgodnie z udzielonym upoważnieniem, przepisami Rodo oraz wewnętrznymi procedurami obowiązującymi u Pracodawcy, w tym Polityką Prywatności,</li>
          <li>zobowiązuję się do zachowania w tajemnicy danych osobowych, do których mam lub będę miał dostęp w związku z wykonywaniem obowiązków na rzecz Tutore Poland Sp. z o.o. oraz zachowania w tajemnicy sposobów zabezpieczenia danych osobowych, również po odwołaniu lub zmianie upoważnienia, a także po zakończeniu trwania umowy o zlecenie .</li>
          </ol>
        </li>
        </ol>
          <div class="right-cointainer" style="float: right; margin-top: 20px;">
            <span style="font-size: 14px;">{{ imieNazwisko }}</span>
            <br>
            <span><strong>czytelny podpis</strong></span>
          </div>
      </td>
    </tr>
  </table>
  </div>

<p class="subheading p-margin" style="text-align: center;">
  data i podpis
  <br>
  <strong>{{ aktualnaData() }} - {{ imieNazwisko }}</strong>
</p>
<p class="subheading p-margin" style="text-align: center;">
  <strong>w imieniu Administratora</strong>
</p>
<p 
	v-if="zamawiajacy.includes('Ewa Szcześniewska')"
	align="center"
>
	<b>{{ zamawiajacy }} – upoważniona przez Administratora</b>
</p>
<p 
	v-else
	align="center"
>
	<b>{{ zamawiajacy }} – upoważniony przez Administratora</b>
</p>
<br>
<p>Niniejsze upoważnienie uchylone zostało w dniu rozwiązania umowy o współpracę.</p>
</div>

<div style="page-break-before: always;">
  <p class="underline">Załącznik nr 4</p>
  <p class="subheading" style="margin-bottom: 0px;"><strong>Informacja o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on - line</strong></p>
  <br>
  <p>Informujemy, iż Tutore Poland Sp. z o.o. korzysta z środków technicznych umożliwiających monitoring prowadzonych zajęć on – line oraz nagrywania szkoleń wewnętrznych on - line. Monitoringiem są objęte urządzenia rejestrujące obraz oraz dźwięk, z których korzysta użytkownik w celu realizacji zajęć online tj. platforma Clickmeeting bądź aplikacja Zoom, a w przypadku szkoleń wewnętrznych online aplikacja Zoom. Tutore Poland Sp. z o.o. stosuje monitoring w następujących celach: zapewnienia najwyższych standardów obsługi zajęć lekcyjnych realizowanych przez pracowników/zleceniobiorców, prawidłowości wykonywania powierzonych czynności oraz ewentualnego poprawienia jakości lekcji, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy), a w przypadku szkoleń wewnętrznych on – line w celu zapewnienia możliwości udostępnienia nagrań nowym pracownikom/zleceniobiorcom. Informujemy, iż: system monitoringu audiowizualnego i dźwiękowego zajęć online składa się z systemu rejestrującego platformy Clickmeeting bądź Zoom oraz serwera, na którym są zapisywane zajęcia online, dostęp do zapisu nagrań zajęć online posiadają osoby upoważnione przez Zarząd Tutore Poland Sp. z o.o. tj. Manager Działu Call Center, Dyrektor ds. Zarządzania Procesami, Teamleader Działu Infolinii, osoby, które mają wgląd do zarejestrowanego obrazu mają świadomość odpowiedzialności za ochronę danych osobowych oraz posiadają stosowne upoważnienie wydane przez Administratora danych osobowych. W toku nagrania dochodzi do przetwarzania danych osobowych w postaci głosu, wizerunku oraz imienia i nazwiska zleceniobiorcy prowadzącego zajęcia lub szkolenie. Administratorem danych osobowych uzyskanych w ramach monitoringu zajęć on – line i w toku nagrywania szkoleń wewnętrznych on - line jest Tutore Poland Sp. z o.o., który w związku z opisaną powyżej czynnością zamieszcza poniżej wymaganą klauzulę informacyjną dotyczącą przetwarzania danych osobowych.
  </p>
  <br>
  <p><strong>Klauzula informacyjna Tutore Poland Sp. z o.o. dla pracowników/zleceniobiorców w związku z przetwarzaniem danych osobowych w ramach monitoringu zajęć on – line i nagrywania szkoleń wewnętrznych on - line</strong></p>
  <p>Na podstawie art. 13 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO, Tutore Poland Sp. z o.o. informuje:</p>
  <ol>
    <li>Administratorem Danych Osobowych jest Tutore Poland Sp. z o.o. z siedzibą przy ul. Piotrkowska 157A, 90-440 Łódź, tel.  535 933 870 info@tutore.eu, dalej ADO.</li>
    <li>ADO przetwarza dane osobowe dla celach wskazanych w informacji monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on - line – podstawę prawną przetwarzania stanowi dobrowolna zgoda nagrywanego (art. 6 ust. 1 lit. a RODO)</li>
    <li>ADO nie przekazuje danych osobowych poza Europejski Obszar Gospodarczy.</li>
    <li>Dane osobowe przechowywane będą przez okres do 3 miesięcy. W przypadku, w którym nagrania zajęć on - line stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub ADO powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu.</li>
    <li>Odbiorcami danych osobowych mogą być organy publiczne, organy wymiaru sprawiedliwości, jednostki świadczące na rzecz ADO usługi doradcze (w szczególności doradztwo prawne).</li>
    <li>Osoba której dane są przetwarzane ma prawo:
      <ol type="a">
        <li>dostępu do swoich danych oraz otrzymania ich kopii,</li>
        <li>prawo do sprostowania (poprawiania) swoich danych,</li>
        <li>prawo do ograniczenia przetwarzania,</li>
        <li>prawo do bycia zapomnianym,</li>
        <li>prawo do sprzeciwu,</li>
        <li>prawo do przenoszenia danych,</li>
        <li>prawo do cofnięcia zgody na przetwarzanie,</li>
        <li>prawo do wniesienia skargi do Urzędu Ochrony Danych Osobowych.</li>
      </ol>
    </li>
    <li>Osoba, której dane są przetwarzane uprawniona jest do cofnięcia zgody na przetwarzanie w każdym czasie, przy czym oświadczenie o cofnięciu zgody wywołuje skutki z chwilą jego złożenia i nie ma wpływu na proces przetwarzania danych przed jego złożeniem.</li>
    <li>Podanie danych osobowych w zakresie objętym klauzulą jest całkowicie dobrowolne, ale niezbędne dla realizacji celu przetwarzania oraz należytej realizacji zawartej przez strony umowy.</li>
    <li>W ramach działalności ADO nie dochodzi do zautomatyzowanego podejmowania decyzji, w tym profilowania, z wykorzystaniem zebranych danych osobowych.</li>
  </ol>
</div>

<div class="container" style="page-break-before: always;">
    <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
      <tr>
        <td id="oswiadczenie">
          <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
          <ol>
        <li>Ja niżej podpisany/a oświadczam, iż:
          <ol type="a">
            <li>
              zapoznałem/am się z Informacją o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on - line oraz Klauzulą informacyjną i przyjmuję ją do wiadomości,
            </li>
            <li>
              treść Informacji i Klauzuli jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący,
            </li>
          </ol>
        </li>
        <li>W sposób całkowicie dobrowolny, wyrażam zgodę na przetwarzanie moich danych osobowych w celach wskazanych w Informacji o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on – line.</li>
        <li>Zostałem/am poinformowany/a, że moje dane osobowe przetwarzane są na podstawie wyrażonej przeze mnie dobrowolnej zgody oraz, że przysługuje mi prawo do jej cofnięcia w każdym czasie, przy czym cofnięcie zgody wywołuje skutki prawne od momentu jego złożenia i będzie pozostawało bez wpływu na przetwarzanie moich danych osobowych dla celów związanych z realizacją badania przed złożeniem oświadczenia o cofnięciu zgody.</li>
        <li>W trybie art. 81 ust.1 ustawy o prawie autorskim i prawach pokrewnych wyrażam zgodę na rozpowszechnianie mojego wizerunku przez Tutore Poland Sp. z o.o. w celach wskazanych w Informacji o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on – line.</li>
        </ol>
          <div class="right-cointainer" style="float: right; margin-top: 20px;">
            <span style="font-size: 14px;">{{ imieNazwisko }}</span>
            <br>
            <span><strong>czytelny podpis Zleceniobiorcy</strong></span>
          </div>
      </td>
    </tr>
  </table>
  </div>

</td>
</tr>

</tbody></table>
  
  </v-container>
</template>

<script>
export default {
  name: 'UmowaHostessaB2B2024',
  data () {
    return {
      zamawiajacy: '',
      imieNazwisko: '',
      zamieszkany: '',
      korespondencyjny: '',
      pesel: '',
      nrRachunku: '',
      nrDowodu: '',
      nrTelefonu: '',
      email: '',
      emeryt: '',
      rencista: '',
      orzeczenieNiepelnosprawnosc: '',
      stopienNiepelnosprawnosc: '',
      student: '',
      jedenyTytulDoUbezpieczenia: '',
      chorobowe: '',
      zatrudnionyUmowaPraca: '',
      nazwaUmowaPraca: '',
      wynagrodzenieUmowaPraca: '',
      ubezpieczenieUmowaPraca: '',
      tytulUbezpieczenieUmowaPraca: '',
      umowaOd: '',
      umowaDo: '',
      urzadSkarbowy: '',
      nrUmowy: '',
      datapocz: '',
      datakon: '',
      wypo: '',
      kwotapokaz: '',
      slowniepokaz: '',
      shortUmowa: '',
      obywatelstwo: '',
      nazwaFirmy: '',
      siedzibaFirmy: '',
      nip: '',
      kontoBankowe: '',
      rodzajUmowy: '',
      przedmiot: '',
      przedmiot1: '',
      stawka1: '',
      stawka1Slownie: '',
      przedmiot2: '',
      stawka2: '',
      stawka2Slownie: '',
      przedmiot3: '',
      stawka3: '',
      stawka3Slownie: ''
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
    shortNrUmowy () {
      let tab = []
      let shortPosition = ''
      tab = this.nrUmowy.split('/')
      switch(tab[3]) {
        case 'Nauczyciel':
          shortPosition = 'Naucz'
          break;
        case 'Metodyk':
          shortPosition = 'Met'
          break
        case 'TworcaMaterialow':
          shortPosition = 'TMat'
          break
        case 'TworcaMaterialowNauczycielMetodyk':
          shortPosition = 'TMatNauMet'
          break
        case 'TworzenieProgramuNauczania':
          shortPosition = 'TPNau'
          break
        case 'AsystentOrganizacyjny':
          shortPosition = 'AOrg'
          break
        case 'MłodszyAsystentOrganizacyjny':
          shortPosition = 'MAOrg'
          break
        case 'TworzenieMap':
          shortPosition = 'TMapMC'
          break
        default:
          shortPosition = tab[3]
      }
      const shortUmowa = `${tab[0]}/${tab[1]}/${tab[2]}/${shortPosition}`
      return shortUmowa
    },
    slownieAngielski() {
      switch(this.kwota) {
        case '25':
          return 'twenty-five'
          break
        case '30':
          return 'thirty'
          break
        case '35':
          return 'thirty-five'
          break
        case '40':
          return 'forty'
          break
        case '45':
          return 'forty-five'
          break
        case '50':
          return 'fifty'
          break
        case '55':
          return 'fifty-five'
          break
        case '60':
          return 'sixty'
          break
        case '65':
          return 'sixty-five'
          break
        case '70':
          return 'seventy'
          break
        case '75':
          return 'seventy-five'
          break
        case '80':
          return 'eighty'
          break
        case '85':
          return 'eighty-five'
          break
        case '90':
          return 'ninety'
          break
        case '95':
          return 'ninety-five'
          break
        default:
          return this.slownie
      }
    },
    slowniePokazAngielski() {
      switch(this.kwotapokaz) {
        case '25':
          return 'twenty-five'
          break
        case '30':
          return 'thirty'
          break
        case '35':
          return 'thirty-five'
          break
        case '40':
          return 'forty'
          break
        case '45':
          return 'forty-five'
          break
        case '50':
          return 'fifty'
          break
        case '55':
          return 'fifty-five'
          break
        case '60':
          return 'sixty'
          break
        case '65':
          return 'sixty-five'
          break
        case '70':
          return 'seventy'
          break
        case '75':
          return 'seventy-five'
          break
        case '80':
          return 'eighty'
          break
        case '85':
          return 'eighty-five'
          break
        case '90':
          return 'ninety'
          break
        case '95':
          return 'ninety-five'
          break
        default:
          return this.slowniepokaz
      }
    },
    dataObowiazywaniaUmowy () {
      if (this.umowaOd === '' || this.umowaOd === '30-12-1899') {
        return 'dnia podpisania umowy przez obie strony'
      } else {
        return `${this.umowaOd} r.`
      }
    },
    zamawiajacyAngielski() {
      if (this.zamawiajacy === 'Marcin Grzelak - Prezes Zarządu') {
        return 'Marcin Grzelak - Chairman of the Board'
      } else {
        return this.zamawiajacy
      }
    },
    aktualnaData() {
      const today = new Date();
      let day = today.getDate();
      if((day+1) <= 10) {
        day = '0' + day
      }
      let month = today.getMonth()+1;
      if ((today.getMonth()+1) < 10) {
        month = '0' + month
      } 
      const todayDate = day+'-'+month+'-'+today.getFullYear()
      return todayDate
    }
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const currentURL = window.location.href
          history.replaceState(history.state, '', '/')
          window.print()
          history.replaceState(history.state, '', currentURL)
        }, 300)
      })
    }
  }
}
</script>

<style scoped>

.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}

table {
  border: 1px;
  border-collapse: collapse;
  table-layout: fixed;
}

th, td {
  border: 1px;
  border-collapse: collapse;
}

.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.cointainer-left {
  width: 20%;
}

.right-cointainer {
  text-align: end;
}

thead {
  display: table-header-group;
}

.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}

.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}

ul.dashed {
  list-style-type: "- ";
  margin: 0;
}

.underline {
  text-decoration: underline;
}

.pageNum {
  position: absolute;
  right: 0px;
  font-size: 14px;
}

#oswiadczenie {
  padding: 20px;
}

.p-margin {
  margin-bottom: 5px !important;
}

.attachments {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/UmowaHostessaB2B2024.vue